import React, { useEffect, useState } from "react";
import PageTitle from "../../../common/PageTitle";
import { checkAuthority } from "../../../utils";
import SiteDetailCard from "../../../components/sites/DetailCard";
import "./Fsr.css"; // Reuse the same style if applicable

const Surveys = () => {
    const [menuItems, setMenuItems] = useState([]);

    const pathname = window.location?.pathname;
    const baseRoute = pathname?.split("/")[1] === "company" ? "/company" : "";

    const permissionList =
        JSON.parse(localStorage.getItem("permissionlist")) || [];

    const submenuPermissions = permissionList[0]?.submenuPermissions || [];

    const hasPermission = (title) =>
        submenuPermissions.some((perm) => perm.submenu === title);

    const getMenuItems = () => {
        const items = [];

        if (submenuPermissions.length === 0) {
            items.push(
                {
                    id: 1,
                    title: "Questionnaire",
                    url: `${baseRoute}/questionnaire/list`,
                },
                {
                    id: 2,
                    title: "Responses",
                    url: `${baseRoute}/questionnaire/responses`,
                }
            );
        } else {
            if (
                checkAuthority("VIEW_QUESTIONNAIRE") &&
                hasPermission("Questionnaire")
            ) {
                items.push({
                    id: 1,
                    title: "Questionnaire",
                    url: `${baseRoute}/questionnaire/list`,
                });
            }

            if (
                checkAuthority("VIEW_RESPONSES") &&
                hasPermission("Responses")
            ) {
                items.push({
                    id: 2,
                    title: "Responses",
                    url: `${baseRoute}/questionnaire/responses`,
                });
            }
        }

        setMenuItems(items);
    };

    useEffect(() => {
        getMenuItems();
    }, [pathname]);

    return (
        <div>
            <PageTitle title={"Questionnaire"} />
            <div className="datacard">
                {menuItems.length > 0 ? (
                    menuItems.map((item) => (
                        <SiteDetailCard key={item.id} title={item.title} url={item.url} />
                    ))
                ) : (
                    <div className="empty-state">No Questionnaire options available.</div>
                )}
            </div>
        </div>
    );
};

export default Surveys;
